// All UI strings for the public MintLab site (landing + support form).
// Default/base language is English. `useT()` falls back to English for any
// missing key, so partial translations are safe.

export const en = {
  "nav.support": "Support",
  "nav.privacy": "Privacy Policy",
  "nav.terms": "Terms of Use",
  "nav.apps": "Apps",

  "hero.tagline": "MOBILE APPS & GAMES",
  "hero.title": "Little apps, made to delight.",
  "hero.subtitle": "MintLab builds playful, relaxing apps used by people all over the world. Need a hand with one of our apps? We're here to help.",
  "hero.cta_support": "Contact Support",
  "hero.cta_apps": "Explore our apps",

  "apps.heading": "Our apps",
  "apps.subheading": "Free, offline-friendly and made to make your day a little better.",
  "apps.view": "Get it on Google Play",
  "apps.soon": "Coming soon",

  "app.fidget.desc": "100+ pop, spin & squish toys to relax. Offline, no sign-up needed.",
  "app.glow.desc": "Draw glowing neon art with symmetry brushes. Free & offline.",
  "app.brainrot.desc": "Tap viral meme sounds — the ultimate chaos soundboard.",
  "app.rain.desc": "Soothing rain & nature sounds to sleep, focus & relax. Mix your own, offline.",
  "app.trap.desc": "One-tap rage platformer — dodge sneaky troll traps across 16 levels.",
  "app.slice.desc": "Satisfying ASMR slicing — cut sand, soap, foam & slime. 100+ shapes, offline.",

  "support.heading": "Need help?",
  "support.intro": "Tell us what's going on and we'll get back to you by email as soon as we can.",
  "support.cta": "Submit an issue",

  "footer.rights": "© {year} MintLab. All rights reserved.",
  "footer.made": "Made with care by MintLab.",

  "form.title": "Submit an issue",
  "form.app_label": "Regarding app",
  "form.email_label": "Your email address",
  "form.email_ph": "you@example.com",
  "form.category_label": "Category",
  "form.category_ph": "Please select issue type",
  "form.cat.crash": "App froze or crashed",
  "form.cat.purchase": "Problem with a purchase",
  "form.cat.ads": "Problem with ads",
  "form.cat.transfer": "Transfer my progress to a new device",
  "form.cat.feature": "Feature request or suggestion",
  "form.cat.other": "Other question",
  "form.desc_label": "Description",
  "form.desc_ph": "Describe your issue in as much detail as you can…",
  "form.agree_pre": "I have read and agree to the",
  "form.agree_mid": "and",
  "form.agree_post": ".",
  "form.marketing": "I'd like to receive news and updates about MintLab apps.",
  "form.submit": "Submit",
  "form.submitting": "Submitting…",
  "form.success_title": "Thank you!",
  "form.success_msg": "Your issue has been submitted. We'll reply to your email soon.",
  "form.success_again": "Submit another issue",
  "form.err_email": "Please enter a valid email address.",
  "form.err_category": "Please select an issue type.",
  "form.err_desc": "Please describe your issue.",
  "form.err_agree": "Please accept the Privacy Policy and Terms of Use.",
  "form.err_generic": "Something went wrong. Please try again in a moment.",
  "form.back_home": "Back to home",
};

export const vi = {
  "nav.support": "Hỗ trợ",
  "nav.privacy": "Chính sách bảo mật",
  "nav.terms": "Điều khoản sử dụng",
  "nav.apps": "Ứng dụng",
  "hero.tagline": "ỨNG DỤNG & TRÒ CHƠI DI ĐỘNG",
  "hero.title": "Những ứng dụng nhỏ, làm bạn vui.",
  "hero.subtitle": "MintLab tạo ra những ứng dụng thư giãn, vui nhộn được người dùng khắp thế giới yêu thích. Cần hỗ trợ một ứng dụng của chúng tôi? Chúng tôi luôn sẵn lòng giúp đỡ.",
  "hero.cta_support": "Liên hệ hỗ trợ",
  "hero.cta_apps": "Khám phá ứng dụng",
  "apps.heading": "Ứng dụng của chúng tôi",
  "apps.subheading": "Miễn phí, dùng được khi ngoại tuyến và giúp ngày của bạn vui hơn một chút.",
  "apps.view": "Tải trên Google Play",
  "apps.soon": "Sắp ra mắt",
  "app.fidget.desc": "Hơn 100 món đồ bóp, xoay & nhấn để thư giãn. Ngoại tuyến, không cần đăng ký.",
  "app.glow.desc": "Vẽ tranh neon phát sáng với cọ đối xứng. Miễn phí & ngoại tuyến.",
  "app.brainrot.desc": "Chạm để nghe âm thanh meme viral — bảng âm thanh hỗn loạn nhất.",
  "app.rain.desc": "Âm thanh mưa & thiên nhiên giúp ngủ ngon, tập trung & thư giãn. Tự phối, ngoại tuyến.",
  "app.trap.desc": "Game đi cảnh một chạm — né bẫy troll cực khó qua 16 màn.",
  "app.slice.desc": "Cắt ASMR siêu đã tay — cát, xà phòng, bọt & slime. Hơn 100 hình, ngoại tuyến.",
  "support.heading": "Cần trợ giúp?",
  "support.intro": "Hãy cho chúng tôi biết vấn đề của bạn, chúng tôi sẽ phản hồi qua email sớm nhất có thể.",
  "support.cta": "Gửi phản ánh",
  "footer.rights": "© {year} MintLab. Bảo lưu mọi quyền.",
  "footer.made": "Được làm tận tâm bởi MintLab.",
  "form.title": "Gửi phản ánh",
  "form.app_label": "Về ứng dụng",
  "form.email_label": "Địa chỉ email của bạn",
  "form.email_ph": "ban@example.com",
  "form.category_label": "Danh mục",
  "form.category_ph": "Vui lòng chọn loại vấn đề",
  "form.cat.crash": "Ứng dụng bị treo hoặc lỗi",
  "form.cat.purchase": "Vấn đề về thanh toán",
  "form.cat.ads": "Vấn đề về quảng cáo",
  "form.cat.transfer": "Chuyển tiến trình sang thiết bị mới",
  "form.cat.feature": "Yêu cầu tính năng hoặc góp ý",
  "form.cat.other": "Câu hỏi khác",
  "form.desc_label": "Mô tả",
  "form.desc_ph": "Mô tả vấn đề của bạn càng chi tiết càng tốt…",
  "form.agree_pre": "Tôi đã đọc và đồng ý với",
  "form.agree_mid": "và",
  "form.agree_post": ".",
  "form.marketing": "Tôi muốn nhận tin tức và cập nhật về các ứng dụng MintLab.",
  "form.submit": "Gửi",
  "form.submitting": "Đang gửi…",
  "form.success_title": "Cảm ơn bạn!",
  "form.success_msg": "Phản ánh của bạn đã được gửi. Chúng tôi sẽ phản hồi qua email sớm.",
  "form.success_again": "Gửi phản ánh khác",
  "form.err_email": "Vui lòng nhập địa chỉ email hợp lệ.",
  "form.err_category": "Vui lòng chọn loại vấn đề.",
  "form.err_desc": "Vui lòng mô tả vấn đề của bạn.",
  "form.err_agree": "Vui lòng chấp nhận Chính sách bảo mật và Điều khoản sử dụng.",
  "form.err_generic": "Đã có lỗi xảy ra. Vui lòng thử lại sau giây lát.",
  "form.back_home": "Về trang chủ",
};

export const es = {
  "nav.support": "Soporte",
  "nav.privacy": "Política de privacidad",
  "nav.terms": "Términos de uso",
  "nav.apps": "Apps",
  "hero.tagline": "APPS Y JUEGOS MÓVILES",
  "hero.title": "Pequeñas apps para alegrarte el día.",
  "hero.subtitle": "MintLab crea apps relajantes y divertidas que usan personas de todo el mundo. ¿Necesitas ayuda con una de nuestras apps? Estamos aquí para ayudarte.",
  "hero.cta_support": "Contactar con soporte",
  "hero.cta_apps": "Explorar nuestras apps",
  "apps.heading": "Nuestras apps",
  "apps.subheading": "Gratis, funcionan sin conexión y hechas para alegrarte el día.",
  "apps.view": "Disponible en Google Play",
  "apps.soon": "Próximamente",
  "app.fidget.desc": "Más de 100 juguetes para apretar, girar y relajarte. Sin conexión, sin registro.",
  "app.glow.desc": "Dibuja arte neón brillante con pinceles de simetría. Gratis y sin conexión.",
  "app.brainrot.desc": "Toca sonidos de memes virales: la mesa de sonidos más caótica.",
  "app.rain.desc": "Sonidos relajantes de lluvia y naturaleza para dormir, concentrarte y relajarte. Mezcla los tuyos, sin conexión.",
  "app.trap.desc": "Plataformas de un toque — esquiva trampas trol en 16 niveles.",
  "app.slice.desc": "Cortes ASMR relajantes — arena, jabón, espuma y slime. Más de 100 formas, sin conexión.",
  "support.heading": "¿Necesitas ayuda?",
  "support.intro": "Cuéntanos qué ocurre y te responderemos por correo lo antes posible.",
  "support.cta": "Enviar un problema",
  "footer.rights": "© {year} MintLab. Todos los derechos reservados.",
  "footer.made": "Hecho con cariño por MintLab.",
  "form.title": "Enviar un problema",
  "form.app_label": "Sobre la app",
  "form.email_label": "Tu dirección de correo",
  "form.email_ph": "tu@ejemplo.com",
  "form.category_label": "Categoría",
  "form.category_ph": "Selecciona el tipo de problema",
  "form.cat.crash": "La app se congeló o se cerró",
  "form.cat.purchase": "Problema con una compra",
  "form.cat.ads": "Problema con los anuncios",
  "form.cat.transfer": "Transferir mi progreso a un nuevo dispositivo",
  "form.cat.feature": "Sugerencia o nueva función",
  "form.cat.other": "Otra pregunta",
  "form.desc_label": "Descripción",
  "form.desc_ph": "Describe tu problema con el mayor detalle posible…",
  "form.agree_pre": "He leído y acepto la",
  "form.agree_mid": "y los",
  "form.agree_post": ".",
  "form.marketing": "Quiero recibir noticias y novedades sobre las apps de MintLab.",
  "form.submit": "Enviar",
  "form.submitting": "Enviando…",
  "form.success_title": "¡Gracias!",
  "form.success_msg": "Hemos recibido tu problema. Te responderemos por correo pronto.",
  "form.success_again": "Enviar otro problema",
  "form.err_email": "Introduce una dirección de correo válida.",
  "form.err_category": "Selecciona un tipo de problema.",
  "form.err_desc": "Describe tu problema.",
  "form.err_agree": "Acepta la Política de privacidad y los Términos de uso.",
  "form.err_generic": "Algo salió mal. Inténtalo de nuevo en un momento.",
  "form.back_home": "Volver al inicio",
};

export const ptBR = {
  "nav.support": "Suporte",
  "nav.privacy": "Política de Privacidade",
  "nav.terms": "Termos de Uso",
  "nav.apps": "Apps",
  "hero.tagline": "APPS E JOGOS PARA CELULAR",
  "hero.title": "Pequenos apps para alegrar seu dia.",
  "hero.subtitle": "A MintLab cria apps relaxantes e divertidos usados por pessoas no mundo todo. Precisa de ajuda com um dos nossos apps? Estamos aqui para ajudar.",
  "hero.cta_support": "Falar com o suporte",
  "hero.cta_apps": "Conheça nossos apps",
  "apps.heading": "Nossos apps",
  "apps.subheading": "Grátis, funcionam offline e feitos para alegrar seu dia.",
  "apps.view": "Disponível no Google Play",
  "apps.soon": "Em breve",
  "app.fidget.desc": "Mais de 100 brinquedos para apertar, girar e relaxar. Offline, sem cadastro.",
  "app.glow.desc": "Desenhe arte neon brilhante com pincéis de simetria. Grátis e offline.",
  "app.brainrot.desc": "Toque sons de memes virais — a mesa de sons mais caótica.",
  "app.rain.desc": "Sons relaxantes de chuva e natureza para dormir, focar e relaxar. Misture os seus, offline.",
  "app.trap.desc": "Plataforma de um toque — desvie de armadilhas troll em 16 fases.",
  "app.slice.desc": "Cortes ASMR satisfatórios — areia, sabão, espuma e slime. Mais de 100 formas, offline.",
  "support.heading": "Precisa de ajuda?",
  "support.intro": "Conte o que está acontecendo e responderemos por e-mail o quanto antes.",
  "support.cta": "Enviar um problema",
  "footer.rights": "© {year} MintLab. Todos os direitos reservados.",
  "footer.made": "Feito com carinho pela MintLab.",
  "form.title": "Enviar um problema",
  "form.app_label": "Sobre o app",
  "form.email_label": "Seu endereço de e-mail",
  "form.email_ph": "voce@exemplo.com",
  "form.category_label": "Categoria",
  "form.category_ph": "Selecione o tipo de problema",
  "form.cat.crash": "O app travou ou fechou",
  "form.cat.purchase": "Problema com uma compra",
  "form.cat.ads": "Problema com anúncios",
  "form.cat.transfer": "Transferir meu progresso para outro aparelho",
  "form.cat.feature": "Sugestão ou novo recurso",
  "form.cat.other": "Outra pergunta",
  "form.desc_label": "Descrição",
  "form.desc_ph": "Descreva seu problema com o máximo de detalhes…",
  "form.agree_pre": "Li e concordo com a",
  "form.agree_mid": "e os",
  "form.agree_post": ".",
  "form.marketing": "Quero receber novidades sobre os apps da MintLab.",
  "form.submit": "Enviar",
  "form.submitting": "Enviando…",
  "form.success_title": "Obrigado!",
  "form.success_msg": "Recebemos seu problema. Responderemos por e-mail em breve.",
  "form.success_again": "Enviar outro problema",
  "form.err_email": "Digite um endereço de e-mail válido.",
  "form.err_category": "Selecione um tipo de problema.",
  "form.err_desc": "Descreva seu problema.",
  "form.err_agree": "Aceite a Política de Privacidade e os Termos de Uso.",
  "form.err_generic": "Algo deu errado. Tente novamente em instantes.",
  "form.back_home": "Voltar ao início",
};

export const hi = {
  "nav.support": "सहायता",
  "nav.privacy": "गोपनीयता नीति",
  "nav.terms": "उपयोग की शर्तें",
  "nav.apps": "ऐप्स",
  "hero.tagline": "मोबाइल ऐप्स और गेम्स",
  "hero.title": "छोटे ऐप्स, आपके दिन को खुशनुमा बनाने के लिए।",
  "hero.subtitle": "MintLab मज़ेदार और सुकून देने वाले ऐप्स बनाता है जिन्हें दुनिया भर के लोग इस्तेमाल करते हैं। हमारे किसी ऐप में मदद चाहिए? हम मदद के लिए यहाँ हैं।",
  "hero.cta_support": "सहायता से संपर्क करें",
  "hero.cta_apps": "हमारे ऐप्स देखें",
  "apps.heading": "हमारे ऐप्स",
  "apps.subheading": "मुफ़्त, ऑफ़लाइन चलने वाले और आपके दिन को बेहतर बनाने के लिए।",
  "apps.view": "Google Play पर पाएँ",
  "apps.soon": "जल्द आ रहा है",
  "app.fidget.desc": "आराम के लिए 100+ पॉप, स्पिन और स्क्विश टॉय। ऑफ़लाइन, बिना साइन-अप।",
  "app.glow.desc": "सिमेट्री ब्रश से चमकती नियॉन आर्ट बनाएँ। मुफ़्त और ऑफ़लाइन।",
  "app.brainrot.desc": "वायरल मीम साउंड बजाएँ — सबसे धमाकेदार साउंडबोर्ड।",
  "app.rain.desc": "सोने, ध्यान और आराम के लिए सुकून भरी बारिश व प्रकृति की ध्वनियाँ। खुद मिक्स करें, ऑफ़लाइन।",
  "app.trap.desc": "एक टैप वाला रेज प्लेटफ़ॉर्मर — 16 लेवल में चालाक ट्रोल जाल से बचें।",
  "app.slice.desc": "सुकून भरी ASMR कटिंग — रेत, साबुन, फ़ोम और स्लाइम। 100+ आकार, ऑफ़लाइन।",
  "support.heading": "मदद चाहिए?",
  "support.intro": "बताएँ क्या समस्या है, हम जल्द से जल्द ईमेल पर जवाब देंगे।",
  "support.cta": "समस्या भेजें",
  "footer.rights": "© {year} MintLab. सर्वाधिकार सुरक्षित।",
  "footer.made": "MintLab द्वारा प्यार से बनाया गया।",
  "form.title": "समस्या भेजें",
  "form.app_label": "किस ऐप के बारे में",
  "form.email_label": "आपका ईमेल पता",
  "form.email_ph": "aap@example.com",
  "form.category_label": "श्रेणी",
  "form.category_ph": "कृपया समस्या का प्रकार चुनें",
  "form.cat.crash": "ऐप रुक गया या क्रैश हुआ",
  "form.cat.purchase": "खरीदारी से जुड़ी समस्या",
  "form.cat.ads": "विज्ञापन से जुड़ी समस्या",
  "form.cat.transfer": "मेरी प्रगति नए डिवाइस पर ले जाएँ",
  "form.cat.feature": "सुझाव या नई सुविधा",
  "form.cat.other": "अन्य प्रश्न",
  "form.desc_label": "विवरण",
  "form.desc_ph": "अपनी समस्या को जितना हो सके विस्तार से बताएँ…",
  "form.agree_pre": "मैंने पढ़ लिया है और सहमत हूँ",
  "form.agree_mid": "और",
  "form.agree_post": "।",
  "form.marketing": "मैं MintLab ऐप्स की खबरें और अपडेट पाना चाहता/चाहती हूँ।",
  "form.submit": "भेजें",
  "form.submitting": "भेजा जा रहा है…",
  "form.success_title": "धन्यवाद!",
  "form.success_msg": "आपकी समस्या भेज दी गई है। हम जल्द ही ईमेल पर जवाब देंगे।",
  "form.success_again": "एक और समस्या भेजें",
  "form.err_email": "कृपया मान्य ईमेल पता दर्ज करें।",
  "form.err_category": "कृपया समस्या का प्रकार चुनें।",
  "form.err_desc": "कृपया अपनी समस्या बताएँ।",
  "form.err_agree": "कृपया गोपनीयता नीति और उपयोग की शर्तें स्वीकार करें।",
  "form.err_generic": "कुछ गड़बड़ हुई। कृपया थोड़ी देर बाद पुनः प्रयास करें।",
  "form.back_home": "होम पर वापस",
};

export const id = {
  "nav.support": "Dukungan",
  "nav.privacy": "Kebijakan Privasi",
  "nav.terms": "Ketentuan Penggunaan",
  "nav.apps": "Aplikasi",
  "hero.tagline": "APLIKASI & GAME SELULER",
  "hero.title": "Aplikasi kecil yang bikin harimu lebih ceria.",
  "hero.subtitle": "MintLab membuat aplikasi seru dan menenangkan yang dipakai orang di seluruh dunia. Butuh bantuan dengan salah satu aplikasi kami? Kami siap membantu.",
  "hero.cta_support": "Hubungi Dukungan",
  "hero.cta_apps": "Jelajahi aplikasi kami",
  "apps.heading": "Aplikasi kami",
  "apps.subheading": "Gratis, bisa offline, dan dibuat untuk membuat harimu lebih baik.",
  "apps.view": "Dapatkan di Google Play",
  "apps.soon": "Segera hadir",
  "app.fidget.desc": "100+ mainan pop, putar & remas untuk relaksasi. Offline, tanpa daftar.",
  "app.glow.desc": "Gambar seni neon menyala dengan kuas simetri. Gratis & offline.",
  "app.brainrot.desc": "Ketuk suara meme viral — soundboard paling kacau.",
  "app.rain.desc": "Suara hujan & alam menenangkan untuk tidur, fokus & relaksasi. Campur sendiri, offline.",
  "app.trap.desc": "Platformer satu ketukan — hindari jebakan troll di 16 level.",
  "app.slice.desc": "Potong ASMR yang memuaskan — pasir, sabun, busa & slime. 100+ bentuk, offline.",
  "support.heading": "Butuh bantuan?",
  "support.intro": "Ceritakan masalahmu dan kami akan membalas lewat email secepatnya.",
  "support.cta": "Kirim masalah",
  "footer.rights": "© {year} MintLab. Hak cipta dilindungi.",
  "footer.made": "Dibuat dengan sepenuh hati oleh MintLab.",
  "form.title": "Kirim masalah",
  "form.app_label": "Mengenai aplikasi",
  "form.email_label": "Alamat email kamu",
  "form.email_ph": "kamu@contoh.com",
  "form.category_label": "Kategori",
  "form.category_ph": "Pilih jenis masalah",
  "form.cat.crash": "Aplikasi macet atau keluar sendiri",
  "form.cat.purchase": "Masalah pembelian",
  "form.cat.ads": "Masalah iklan",
  "form.cat.transfer": "Pindahkan progres ke perangkat baru",
  "form.cat.feature": "Saran atau fitur baru",
  "form.cat.other": "Pertanyaan lain",
  "form.desc_label": "Deskripsi",
  "form.desc_ph": "Jelaskan masalahmu sedetail mungkin…",
  "form.agree_pre": "Saya telah membaca dan menyetujui",
  "form.agree_mid": "dan",
  "form.agree_post": ".",
  "form.marketing": "Saya ingin menerima kabar dan pembaruan tentang aplikasi MintLab.",
  "form.submit": "Kirim",
  "form.submitting": "Mengirim…",
  "form.success_title": "Terima kasih!",
  "form.success_msg": "Masalahmu sudah terkirim. Kami akan membalas lewat email segera.",
  "form.success_again": "Kirim masalah lain",
  "form.err_email": "Masukkan alamat email yang valid.",
  "form.err_category": "Pilih jenis masalah.",
  "form.err_desc": "Jelaskan masalahmu.",
  "form.err_agree": "Setujui Kebijakan Privasi dan Ketentuan Penggunaan.",
  "form.err_generic": "Terjadi kesalahan. Coba lagi sebentar.",
  "form.back_home": "Kembali ke beranda",
};

export const ru = {
  "nav.support": "Поддержка",
  "nav.privacy": "Политика конфиденциальности",
  "nav.terms": "Условия использования",
  "nav.apps": "Приложения",
  "hero.tagline": "МОБИЛЬНЫЕ ПРИЛОЖЕНИЯ И ИГРЫ",
  "hero.title": "Маленькие приложения, чтобы поднять настроение.",
  "hero.subtitle": "MintLab создаёт весёлые и расслабляющие приложения, которыми пользуются люди по всему миру. Нужна помощь с нашим приложением? Мы рады помочь.",
  "hero.cta_support": "Связаться с поддержкой",
  "hero.cta_apps": "Наши приложения",
  "apps.heading": "Наши приложения",
  "apps.subheading": "Бесплатные, работают офлайн и делают ваш день чуточку лучше.",
  "apps.view": "Скачать в Google Play",
  "apps.soon": "Скоро",
  "app.fidget.desc": "100+ игрушек, чтобы лопать, крутить и сжимать. Офлайн, без регистрации.",
  "app.glow.desc": "Рисуйте светящееся неоновое искусство кистями симметрии. Бесплатно и офлайн.",
  "app.brainrot.desc": "Нажимайте на вирусные мем-звуки — самый хаотичный саундборд.",
  "app.rain.desc": "Успокаивающие звуки дождя и природы для сна, концентрации и отдыха. Создавайте свой микс, офлайн.",
  "app.trap.desc": "Платформер в одно касание — уворачивайтесь от троллинг-ловушек на 16 уровнях.",
  "app.slice.desc": "Залипательная ASMR-резка — песок, мыло, пена и слайм. 100+ фигур, офлайн.",
  "support.heading": "Нужна помощь?",
  "support.intro": "Расскажите, что случилось, и мы ответим вам по электронной почте как можно скорее.",
  "support.cta": "Сообщить о проблеме",
  "footer.rights": "© {year} MintLab. Все права защищены.",
  "footer.made": "Сделано с любовью в MintLab.",
  "form.title": "Сообщить о проблеме",
  "form.app_label": "О приложении",
  "form.email_label": "Ваш адрес электронной почты",
  "form.email_ph": "you@example.com",
  "form.category_label": "Категория",
  "form.category_ph": "Выберите тип проблемы",
  "form.cat.crash": "Приложение зависло или вылетело",
  "form.cat.purchase": "Проблема с покупкой",
  "form.cat.ads": "Проблема с рекламой",
  "form.cat.transfer": "Перенести прогресс на новое устройство",
  "form.cat.feature": "Предложение или новая функция",
  "form.cat.other": "Другой вопрос",
  "form.desc_label": "Описание",
  "form.desc_ph": "Опишите проблему как можно подробнее…",
  "form.agree_pre": "Я прочитал(а) и принимаю",
  "form.agree_mid": "и",
  "form.agree_post": ".",
  "form.marketing": "Я хочу получать новости и обновления о приложениях MintLab.",
  "form.submit": "Отправить",
  "form.submitting": "Отправка…",
  "form.success_title": "Спасибо!",
  "form.success_msg": "Ваше сообщение отправлено. Мы скоро ответим вам по электронной почте.",
  "form.success_again": "Сообщить о другой проблеме",
  "form.err_email": "Введите корректный адрес электронной почты.",
  "form.err_category": "Выберите тип проблемы.",
  "form.err_desc": "Опишите вашу проблему.",
  "form.err_agree": "Примите Политику конфиденциальности и Условия использования.",
  "form.err_generic": "Что-то пошло не так. Попробуйте ещё раз через минуту.",
  "form.back_home": "На главную",
};

export const tr = {
  "nav.support": "Destek",
  "nav.privacy": "Gizlilik Politikası",
  "nav.terms": "Kullanım Koşulları",
  "nav.apps": "Uygulamalar",
  "hero.tagline": "MOBİL UYGULAMALAR VE OYUNLAR",
  "hero.title": "Gününüzü güzelleştiren küçük uygulamalar.",
  "hero.subtitle": "MintLab, dünyanın her yerinden insanların kullandığı eğlenceli ve rahatlatıcı uygulamalar geliştirir. Uygulamalarımızdan biriyle ilgili yardıma mı ihtiyacınız var? Buradayız.",
  "hero.cta_support": "Destekle iletişime geç",
  "hero.cta_apps": "Uygulamaları keşfet",
  "apps.heading": "Uygulamalarımız",
  "apps.subheading": "Ücretsiz, çevrimdışı çalışır ve gününüzü güzelleştirmek için tasarlandı.",
  "apps.view": "Google Play'den edinin",
  "apps.soon": "Çok yakında",
  "app.fidget.desc": "Rahatlamak için 100+ patlat, döndür ve sık oyuncağı. Çevrimdışı, kayıt yok.",
  "app.glow.desc": "Simetri fırçalarıyla parlayan neon sanat çizin. Ücretsiz ve çevrimdışı.",
  "app.brainrot.desc": "Viral mizah seslerine dokun — en çılgın ses panosu.",
  "app.rain.desc": "Uyumak, odaklanmak ve rahatlamak için yatıştırıcı yağmur ve doğa sesleri. Kendi miksini yap, çevrimdışı.",
  "app.trap.desc": "Tek dokunuşlu sinir platform oyunu — 16 bölümde sinsi tuzaklardan kaç.",
  "app.slice.desc": "Tatmin edici ASMR kesme — kum, sabun, köpük ve slime. 100+ şekil, çevrimdışı.",
  "support.heading": "Yardım mı lazım?",
  "support.intro": "Sorununuzu bize anlatın, en kısa sürede e-posta ile yanıtlayalım.",
  "support.cta": "Sorun bildir",
  "footer.rights": "© {year} MintLab. Tüm hakları saklıdır.",
  "footer.made": "MintLab tarafından özenle yapıldı.",
  "form.title": "Sorun bildir",
  "form.app_label": "Uygulama hakkında",
  "form.email_label": "E-posta adresiniz",
  "form.email_ph": "siz@ornek.com",
  "form.category_label": "Kategori",
  "form.category_ph": "Lütfen sorun türünü seçin",
  "form.cat.crash": "Uygulama dondu veya çöktü",
  "form.cat.purchase": "Satın alma sorunu",
  "form.cat.ads": "Reklam sorunu",
  "form.cat.transfer": "İlerlememi yeni cihaza aktar",
  "form.cat.feature": "Öneri veya yeni özellik",
  "form.cat.other": "Diğer soru",
  "form.desc_label": "Açıklama",
  "form.desc_ph": "Sorununuzu olabildiğince ayrıntılı anlatın…",
  "form.agree_pre": "Okudum ve kabul ediyorum:",
  "form.agree_mid": "ve",
  "form.agree_post": ".",
  "form.marketing": "MintLab uygulamaları hakkında haber ve güncellemeler almak istiyorum.",
  "form.submit": "Gönder",
  "form.submitting": "Gönderiliyor…",
  "form.success_title": "Teşekkürler!",
  "form.success_msg": "Sorununuz gönderildi. Kısa süre içinde e-posta ile yanıtlayacağız.",
  "form.success_again": "Başka bir sorun bildir",
  "form.err_email": "Geçerli bir e-posta adresi girin.",
  "form.err_category": "Bir sorun türü seçin.",
  "form.err_desc": "Lütfen sorununuzu açıklayın.",
  "form.err_agree": "Lütfen Gizlilik Politikası ve Kullanım Koşullarını kabul edin.",
  "form.err_generic": "Bir şeyler ters gitti. Lütfen birazdan tekrar deneyin.",
  "form.back_home": "Ana sayfaya dön",
};

export const de = {
  "nav.support": "Support",
  "nav.privacy": "Datenschutzerklärung",
  "nav.terms": "Nutzungsbedingungen",
  "nav.apps": "Apps",
  "hero.tagline": "MOBILE APPS & SPIELE",
  "hero.title": "Kleine Apps, die den Tag versüßen.",
  "hero.subtitle": "MintLab entwickelt verspielte, entspannende Apps, die Menschen auf der ganzen Welt nutzen. Brauchst du Hilfe mit einer unserer Apps? Wir sind für dich da.",
  "hero.cta_support": "Support kontaktieren",
  "hero.cta_apps": "Apps entdecken",
  "apps.heading": "Unsere Apps",
  "apps.subheading": "Kostenlos, offline nutzbar und gemacht, um deinen Tag schöner zu machen.",
  "apps.view": "Bei Google Play",
  "apps.soon": "Demnächst",
  "app.fidget.desc": "Über 100 Pop-, Dreh- und Knautsch-Spielzeuge zum Entspannen. Offline, ohne Anmeldung.",
  "app.glow.desc": "Male leuchtende Neon-Kunst mit Symmetrie-Pinseln. Kostenlos & offline.",
  "app.brainrot.desc": "Tippe auf virale Meme-Sounds – das ultimative Chaos-Soundboard.",
  "app.rain.desc": "Beruhigende Regen- und Naturgeräusche zum Schlafen, Fokussieren & Entspannen. Mische deine eigenen, offline.",
  "app.trap.desc": "Ein-Tipp-Rage-Plattformer — weiche fiesen Troll-Fallen in 16 Levels aus.",
  "app.slice.desc": "Befriedigendes ASMR-Schneiden — Sand, Seife, Schaum & Slime. 100+ Formen, offline.",
  "support.heading": "Brauchst du Hilfe?",
  "support.intro": "Erzähl uns, was los ist, und wir melden uns so schnell wie möglich per E-Mail.",
  "support.cta": "Problem melden",
  "footer.rights": "© {year} MintLab. Alle Rechte vorbehalten.",
  "footer.made": "Mit Sorgfalt gemacht von MintLab.",
  "form.title": "Problem melden",
  "form.app_label": "Betrifft App",
  "form.email_label": "Deine E-Mail-Adresse",
  "form.email_ph": "du@beispiel.com",
  "form.category_label": "Kategorie",
  "form.category_ph": "Bitte Problemtyp wählen",
  "form.cat.crash": "App eingefroren oder abgestürzt",
  "form.cat.purchase": "Problem mit einem Kauf",
  "form.cat.ads": "Problem mit Werbung",
  "form.cat.transfer": "Fortschritt auf neues Gerät übertragen",
  "form.cat.feature": "Vorschlag oder neue Funktion",
  "form.cat.other": "Andere Frage",
  "form.desc_label": "Beschreibung",
  "form.desc_ph": "Beschreibe dein Problem so genau wie möglich…",
  "form.agree_pre": "Ich habe die",
  "form.agree_mid": "und die",
  "form.agree_post": "gelesen und akzeptiere sie.",
  "form.marketing": "Ich möchte Neuigkeiten und Updates zu MintLab-Apps erhalten.",
  "form.submit": "Senden",
  "form.submitting": "Wird gesendet…",
  "form.success_title": "Danke!",
  "form.success_msg": "Dein Problem wurde gesendet. Wir antworten dir bald per E-Mail.",
  "form.success_again": "Weiteres Problem melden",
  "form.err_email": "Bitte gib eine gültige E-Mail-Adresse ein.",
  "form.err_category": "Bitte wähle einen Problemtyp.",
  "form.err_desc": "Bitte beschreibe dein Problem.",
  "form.err_agree": "Bitte akzeptiere die Datenschutzerklärung und die Nutzungsbedingungen.",
  "form.err_generic": "Etwas ist schiefgelaufen. Bitte versuche es gleich noch einmal.",
  "form.back_home": "Zurück zur Startseite",
};

export const fr = {
  "nav.support": "Assistance",
  "nav.privacy": "Politique de confidentialité",
  "nav.terms": "Conditions d'utilisation",
  "nav.apps": "Applis",
  "hero.tagline": "APPLIS & JEUX MOBILES",
  "hero.title": "De petites applis pour égayer votre journée.",
  "hero.subtitle": "MintLab crée des applis ludiques et relaxantes utilisées partout dans le monde. Besoin d'aide avec l'une de nos applis ? Nous sommes là pour vous.",
  "hero.cta_support": "Contacter l'assistance",
  "hero.cta_apps": "Découvrir nos applis",
  "apps.heading": "Nos applis",
  "apps.subheading": "Gratuites, utilisables hors ligne et faites pour égayer votre journée.",
  "apps.view": "Disponible sur Google Play",
  "apps.soon": "Bientôt disponible",
  "app.fidget.desc": "Plus de 100 jouets à presser, tourner et triturer pour se détendre. Hors ligne, sans inscription.",
  "app.glow.desc": "Dessinez de l'art néon lumineux avec des pinceaux de symétrie. Gratuit et hors ligne.",
  "app.brainrot.desc": "Touchez des sons de mèmes viraux — le soundboard le plus déjanté.",
  "app.rain.desc": "Sons apaisants de pluie et de nature pour dormir, se concentrer et se détendre. Composez les vôtres, hors ligne.",
  "app.trap.desc": "Plateformer à une touche — esquive les pièges trolls sur 16 niveaux.",
  "app.slice.desc": "Découpe ASMR satisfaisante — sable, savon, mousse et slime. Plus de 100 formes, hors ligne.",
  "support.heading": "Besoin d'aide ?",
  "support.intro": "Dites-nous ce qui se passe et nous vous répondrons par e-mail dès que possible.",
  "support.cta": "Signaler un problème",
  "footer.rights": "© {year} MintLab. Tous droits réservés.",
  "footer.made": "Conçu avec soin par MintLab.",
  "form.title": "Signaler un problème",
  "form.app_label": "Concernant l'appli",
  "form.email_label": "Votre adresse e-mail",
  "form.email_ph": "vous@exemple.com",
  "form.category_label": "Catégorie",
  "form.category_ph": "Veuillez choisir le type de problème",
  "form.cat.crash": "L'appli a planté ou s'est figée",
  "form.cat.purchase": "Problème avec un achat",
  "form.cat.ads": "Problème avec les publicités",
  "form.cat.transfer": "Transférer ma progression vers un nouvel appareil",
  "form.cat.feature": "Suggestion ou nouvelle fonctionnalité",
  "form.cat.other": "Autre question",
  "form.desc_label": "Description",
  "form.desc_ph": "Décrivez votre problème aussi précisément que possible…",
  "form.agree_pre": "J'ai lu et j'accepte la",
  "form.agree_mid": "et les",
  "form.agree_post": ".",
  "form.marketing": "Je souhaite recevoir des nouvelles et des mises à jour des applis MintLab.",
  "form.submit": "Envoyer",
  "form.submitting": "Envoi…",
  "form.success_title": "Merci !",
  "form.success_msg": "Votre problème a été envoyé. Nous vous répondrons bientôt par e-mail.",
  "form.success_again": "Signaler un autre problème",
  "form.err_email": "Veuillez saisir une adresse e-mail valide.",
  "form.err_category": "Veuillez choisir un type de problème.",
  "form.err_desc": "Veuillez décrire votre problème.",
  "form.err_agree": "Veuillez accepter la Politique de confidentialité et les Conditions d'utilisation.",
  "form.err_generic": "Une erreur s'est produite. Veuillez réessayer dans un instant.",
  "form.back_home": "Retour à l'accueil",
};

export const ja = {
  "nav.support": "サポート",
  "nav.privacy": "プライバシーポリシー",
  "nav.terms": "利用規約",
  "nav.apps": "アプリ",
  "hero.tagline": "モバイルアプリ＆ゲーム",
  "hero.title": "毎日をちょっと楽しくする小さなアプリ。",
  "hero.subtitle": "MintLabは、世界中の人々に使われている遊び心あふれるリラックス系アプリを作っています。アプリのことでお困りですか？お手伝いします。",
  "hero.cta_support": "サポートに問い合わせ",
  "hero.cta_apps": "アプリを見る",
  "apps.heading": "私たちのアプリ",
  "apps.subheading": "無料・オフライン対応で、毎日をちょっと良くするアプリ。",
  "apps.view": "Google Play で入手",
  "apps.soon": "近日公開",
  "app.fidget.desc": "100種類以上のポップ・スピン・スクイーズで癒される。オフライン、登録不要。",
  "app.glow.desc": "対称ブラシで光るネオンアートを描こう。無料＆オフライン。",
  "app.brainrot.desc": "バズったミーム効果音をタップ。最高にカオスなサウンドボード。",
  "app.rain.desc": "眠り・集中・リラックスのための癒やしの雨と自然の音。自分好みにミックス、オフライン対応。",
  "app.trap.desc": "ワンタップの激ムズアクション — 16ステージの意地悪なトラップを回避。",
  "app.slice.desc": "気持ちいいASMRカット — 砂・石けん・泡・スライム。100種類以上、オフライン対応。",
  "support.heading": "お困りですか？",
  "support.intro": "状況をお知らせください。できるだけ早くメールで返信します。",
  "support.cta": "問題を報告",
  "footer.rights": "© {year} MintLab. All rights reserved.",
  "footer.made": "MintLab が心を込めて制作。",
  "form.title": "問題を報告",
  "form.app_label": "対象アプリ",
  "form.email_label": "メールアドレス",
  "form.email_ph": "you@example.com",
  "form.category_label": "カテゴリー",
  "form.category_ph": "問題の種類を選択してください",
  "form.cat.crash": "アプリがフリーズ・クラッシュした",
  "form.cat.purchase": "購入に関する問題",
  "form.cat.ads": "広告に関する問題",
  "form.cat.transfer": "進行状況を新しい端末に引き継ぐ",
  "form.cat.feature": "ご要望・新機能の提案",
  "form.cat.other": "その他の質問",
  "form.desc_label": "詳細",
  "form.desc_ph": "問題をできるだけ詳しくご記入ください…",
  "form.agree_pre": "私は次に同意します：",
  "form.agree_mid": "および",
  "form.agree_post": "。",
  "form.marketing": "MintLabアプリのニュースやアップデートを受け取りたい。",
  "form.submit": "送信",
  "form.submitting": "送信中…",
  "form.success_title": "ありがとうございます！",
  "form.success_msg": "問題が送信されました。まもなくメールで返信します。",
  "form.success_again": "別の問題を報告",
  "form.err_email": "有効なメールアドレスを入力してください。",
  "form.err_category": "問題の種類を選択してください。",
  "form.err_desc": "問題の内容をご記入ください。",
  "form.err_agree": "プライバシーポリシーと利用規約に同意してください。",
  "form.err_generic": "問題が発生しました。しばらくしてからもう一度お試しください。",
  "form.back_home": "ホームに戻る",
};

export const ko = {
  "nav.support": "고객지원",
  "nav.privacy": "개인정보처리방침",
  "nav.terms": "이용약관",
  "nav.apps": "앱",
  "hero.tagline": "모바일 앱 & 게임",
  "hero.title": "하루를 즐겁게 만드는 작은 앱들.",
  "hero.subtitle": "MintLab은 전 세계 사람들이 사용하는 재미있고 편안한 앱을 만듭니다. 저희 앱에 도움이 필요하신가요? 기꺼이 도와드릴게요.",
  "hero.cta_support": "고객지원 문의",
  "hero.cta_apps": "앱 둘러보기",
  "apps.heading": "우리의 앱",
  "apps.subheading": "무료, 오프라인 지원, 그리고 당신의 하루를 더 좋게.",
  "apps.view": "Google Play에서 받기",
  "apps.soon": "출시 예정",
  "app.fidget.desc": "팝·스핀·스퀴시 장난감 100여 종으로 힐링하세요. 오프라인, 가입 불필요.",
  "app.glow.desc": "대칭 브러시로 빛나는 네온 아트를 그려보세요. 무료 & 오프라인.",
  "app.brainrot.desc": "인기 밈 사운드를 탭하세요 — 최고로 정신없는 사운드보드.",
  "app.rain.desc": "수면, 집중, 휴식을 위한 편안한 빗소리와 자연의 소리. 나만의 믹스, 오프라인.",
  "app.trap.desc": "원탭 분노 플랫포머 — 16개 레벨의 교묘한 함정을 피하세요.",
  "app.slice.desc": "손맛 가득 ASMR 자르기 — 모래, 비누, 거품, 슬라임. 100가지 이상, 오프라인.",
  "support.heading": "도움이 필요하세요?",
  "support.intro": "무슨 일인지 알려주시면 최대한 빨리 이메일로 답변드릴게요.",
  "support.cta": "문제 제출",
  "footer.rights": "© {year} MintLab. All rights reserved.",
  "footer.made": "MintLab이 정성껏 만들었습니다.",
  "form.title": "문제 제출",
  "form.app_label": "관련 앱",
  "form.email_label": "이메일 주소",
  "form.email_ph": "you@example.com",
  "form.category_label": "카테고리",
  "form.category_ph": "문제 유형을 선택하세요",
  "form.cat.crash": "앱이 멈추거나 종료됨",
  "form.cat.purchase": "결제 문제",
  "form.cat.ads": "광고 문제",
  "form.cat.transfer": "진행 상황을 새 기기로 이전",
  "form.cat.feature": "제안 또는 새 기능",
  "form.cat.other": "기타 문의",
  "form.desc_label": "설명",
  "form.desc_ph": "문제를 최대한 자세히 설명해 주세요…",
  "form.agree_pre": "다음에 동의합니다:",
  "form.agree_mid": "및",
  "form.agree_post": ".",
  "form.marketing": "MintLab 앱의 소식과 업데이트를 받고 싶어요.",
  "form.submit": "제출",
  "form.submitting": "제출 중…",
  "form.success_title": "감사합니다!",
  "form.success_msg": "문제가 제출되었습니다. 곧 이메일로 답변드리겠습니다.",
  "form.success_again": "다른 문제 제출",
  "form.err_email": "올바른 이메일 주소를 입력하세요.",
  "form.err_category": "문제 유형을 선택하세요.",
  "form.err_desc": "문제를 설명해 주세요.",
  "form.err_agree": "개인정보처리방침과 이용약관에 동의해 주세요.",
  "form.err_generic": "문제가 발생했습니다. 잠시 후 다시 시도해 주세요.",
  "form.back_home": "홈으로 돌아가기",
};

export const th = {
  "nav.support": "ฝ่ายช่วยเหลือ",
  "nav.privacy": "นโยบายความเป็นส่วนตัว",
  "nav.terms": "ข้อกำหนดการใช้งาน",
  "nav.apps": "แอป",
  "hero.tagline": "แอปและเกมบนมือถือ",
  "hero.title": "แอปเล็ก ๆ ที่ทำให้วันของคุณสดใสขึ้น",
  "hero.subtitle": "MintLab สร้างแอปสนุก ๆ ผ่อนคลายที่ผู้คนทั่วโลกใช้งาน ต้องการความช่วยเหลือเกี่ยวกับแอปของเราไหม เรายินดีช่วยเสมอ",
  "hero.cta_support": "ติดต่อฝ่ายช่วยเหลือ",
  "hero.cta_apps": "สำรวจแอปของเรา",
  "apps.heading": "แอปของเรา",
  "apps.subheading": "ฟรี ใช้ได้แบบออฟไลน์ และสร้างมาเพื่อทำให้วันของคุณดีขึ้น",
  "apps.view": "ดาวน์โหลดบน Google Play",
  "apps.soon": "เร็วๆ นี้",
  "app.fidget.desc": "ของเล่นกด หมุน บีบ กว่า 100 ชิ้นเพื่อผ่อนคลาย ออฟไลน์ ไม่ต้องสมัคร",
  "app.glow.desc": "วาดศิลปะนีออนเรืองแสงด้วยแปรงสมมาตร ฟรีและออฟไลน์",
  "app.brainrot.desc": "แตะเสียงมีมไวรัล — ซาวด์บอร์ดสุดป่วน",
  "app.rain.desc": "เสียงฝนและธรรมชาติผ่อนคลายเพื่อการนอน สมาธิ และพักผ่อน ผสมเองได้ ออฟไลน์",
  "app.trap.desc": "เกมแพลตฟอร์มแตะครั้งเดียว — หลบกับดักสุดแสบใน 16 ด่าน",
  "app.slice.desc": "ตัด ASMR สุดฟิน — ทราย สบู่ โฟม และสไลม์ กว่า 100 รูปทรง ออฟไลน์",
  "support.heading": "ต้องการความช่วยเหลือ?",
  "support.intro": "บอกเราว่าเกิดอะไรขึ้น แล้วเราจะตอบกลับทางอีเมลโดยเร็วที่สุด",
  "support.cta": "ส่งปัญหา",
  "footer.rights": "© {year} MintLab สงวนลิขสิทธิ์",
  "footer.made": "สร้างด้วยใจโดย MintLab",
  "form.title": "ส่งปัญหา",
  "form.app_label": "เกี่ยวกับแอป",
  "form.email_label": "อีเมลของคุณ",
  "form.email_ph": "you@example.com",
  "form.category_label": "หมวดหมู่",
  "form.category_ph": "โปรดเลือกประเภทปัญหา",
  "form.cat.crash": "แอปค้างหรือปิดเอง",
  "form.cat.purchase": "ปัญหาการชำระเงิน",
  "form.cat.ads": "ปัญหาเกี่ยวกับโฆษณา",
  "form.cat.transfer": "ย้ายความคืบหน้าไปยังเครื่องใหม่",
  "form.cat.feature": "ข้อเสนอแนะหรือฟีเจอร์ใหม่",
  "form.cat.other": "คำถามอื่น ๆ",
  "form.desc_label": "รายละเอียด",
  "form.desc_ph": "อธิบายปัญหาของคุณให้ละเอียดที่สุด…",
  "form.agree_pre": "ฉันได้อ่านและยอมรับ",
  "form.agree_mid": "และ",
  "form.agree_post": "",
  "form.marketing": "ฉันต้องการรับข่าวสารและอัปเดตเกี่ยวกับแอป MintLab",
  "form.submit": "ส่ง",
  "form.submitting": "กำลังส่ง…",
  "form.success_title": "ขอบคุณ!",
  "form.success_msg": "ส่งปัญหาของคุณแล้ว เราจะตอบกลับทางอีเมลเร็ว ๆ นี้",
  "form.success_again": "ส่งปัญหาอีกครั้ง",
  "form.err_email": "โปรดกรอกอีเมลที่ถูกต้อง",
  "form.err_category": "โปรดเลือกประเภทปัญหา",
  "form.err_desc": "โปรดอธิบายปัญหาของคุณ",
  "form.err_agree": "โปรดยอมรับนโยบายความเป็นส่วนตัวและข้อกำหนดการใช้งาน",
  "form.err_generic": "เกิดข้อผิดพลาด โปรดลองอีกครั้งในอีกสักครู่",
  "form.back_home": "กลับสู่หน้าแรก",
};

export const ar = {
  "nav.support": "الدعم",
  "nav.privacy": "سياسة الخصوصية",
  "nav.terms": "شروط الاستخدام",
  "nav.apps": "التطبيقات",
  "hero.tagline": "تطبيقات وألعاب للجوال",
  "hero.title": "تطبيقات صغيرة تُبهج يومك.",
  "hero.subtitle": "تصنع MintLab تطبيقات ممتعة ومريحة يستخدمها أشخاص من جميع أنحاء العالم. تحتاج مساعدة في أحد تطبيقاتنا؟ نحن هنا لمساعدتك.",
  "hero.cta_support": "تواصل مع الدعم",
  "hero.cta_apps": "استكشف تطبيقاتنا",
  "apps.heading": "تطبيقاتنا",
  "apps.subheading": "مجانية وتعمل دون اتصال، وصُنعت لتجعل يومك أفضل.",
  "apps.view": "احصل عليه من Google Play",
  "apps.soon": "قريبًا",
  "app.fidget.desc": "أكثر من 100 لعبة للضغط والدوران والعصر للاسترخاء. دون اتصال وبدون تسجيل.",
  "app.glow.desc": "ارسم فنًا نيونيًا متوهجًا بفرش التناظر. مجاني ودون اتصال.",
  "app.brainrot.desc": "اضغط على أصوات الميمات الرائجة — لوحة الأصوات الأكثر جنونًا.",
  "app.rain.desc": "أصوات مطر وطبيعة مهدّئة للنوم والتركيز والاسترخاء. امزج ما تريد، دون اتصال.",
  "app.trap.desc": "لعبة منصات بلمسة واحدة — تفادَ الفخاخ الماكرة عبر 16 مستوى.",
  "app.slice.desc": "تقطيع ASMR ممتع — رمل وصابون ورغوة وسلايم. أكثر من 100 شكل، دون اتصال.",
  "support.heading": "تحتاج مساعدة؟",
  "support.intro": "أخبرنا بما يحدث وسنرد عليك عبر البريد الإلكتروني في أقرب وقت.",
  "support.cta": "إرسال مشكلة",
  "footer.rights": "© {year} MintLab. جميع الحقوق محفوظة.",
  "footer.made": "صُنع بعناية بواسطة MintLab.",
  "form.title": "إرسال مشكلة",
  "form.app_label": "بخصوص التطبيق",
  "form.email_label": "بريدك الإلكتروني",
  "form.email_ph": "you@example.com",
  "form.category_label": "الفئة",
  "form.category_ph": "يرجى اختيار نوع المشكلة",
  "form.cat.crash": "تجمّد التطبيق أو تعطّل",
  "form.cat.purchase": "مشكلة في عملية شراء",
  "form.cat.ads": "مشكلة في الإعلانات",
  "form.cat.transfer": "نقل تقدّمي إلى جهاز جديد",
  "form.cat.feature": "اقتراح أو ميزة جديدة",
  "form.cat.other": "سؤال آخر",
  "form.desc_label": "الوصف",
  "form.desc_ph": "صف مشكلتك بأكبر قدر ممكن من التفاصيل…",
  "form.agree_pre": "لقد قرأت وأوافق على",
  "form.agree_mid": "و",
  "form.agree_post": ".",
  "form.marketing": "أرغب في تلقي الأخبار والتحديثات عن تطبيقات MintLab.",
  "form.submit": "إرسال",
  "form.submitting": "جارٍ الإرسال…",
  "form.success_title": "شكرًا لك!",
  "form.success_msg": "تم إرسال مشكلتك. سنرد عليك عبر البريد الإلكتروني قريبًا.",
  "form.success_again": "إرسال مشكلة أخرى",
  "form.err_email": "يرجى إدخال بريد إلكتروني صالح.",
  "form.err_category": "يرجى اختيار نوع المشكلة.",
  "form.err_desc": "يرجى وصف مشكلتك.",
  "form.err_agree": "يرجى قبول سياسة الخصوصية وشروط الاستخدام.",
  "form.err_generic": "حدث خطأ ما. يرجى المحاولة مرة أخرى بعد قليل.",
  "form.back_home": "العودة إلى الصفحة الرئيسية",
};

export const translations = {
  en, vi, es, "pt-BR": ptBR, hi, id, ru, tr, de, fr, ja, ko, th, ar,
};
